import React, { useState } from 'react';

interface PageableTableProps<T> {
  data: T[];
  headers: string[];
  renderRow: (item: T, index: number) => React.ReactNode;
  itemsPerPage: number;
}

const PageableTable = ({ data, headers, renderRow, itemsPerPage }: PageableTableProps<any>) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const filteredData = data.filter((item) => JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase()));

  const totalItems = filteredData.length;

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  return (
    <div className='grid grid-flex'>
      <div className='grid-item three-fourth font-highlight align-bottom grid-align-end'>
        Total: {data.length} Page {currentPage}/{totalPages}
      </div>
      <div className='grid-item one-fourth grid-align-end'>
        <input
          type='text'
          className='input-text align-left '
          placeholder='Search'
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
      <table className='table'>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th className='font-highlight' key={index}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{currentItems.map(renderRow)}</tbody>
      </table>
      <div className='grid-item three-fourth'>
        {totalItems > itemsPerPage && (
          <ul className='pagination'>
            <li className='page-item'>
              <button
                className='button-primary button-margin'
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            </li>
            <li className='page-item'>
              <button className='button-primary' onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default PageableTable;
